import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { first } from 'rxjs/operators';
import { Router } from '@angular/router';
import {RcEventBusService} from '../../rc-utils/rc-event-bus/rc-event-bus.service';
import {RcAuthService} from '../../rc-utils/rc-auth/rc-auth.service';


@Component({
  selector: 'lib-rc-otp',
  template: `

  <div  class="send-otp-text" *ngIf="isInSendOtp">
    <p>
      {{otpSendMessage}}
    </p>
  </div>

  <div class="form-group" [hidden]="!isInSendOtp">
    <lib-rc-input type="number" class="lib-rc-input" [label]="'otp'"  [control]="otp" [elementId]="'Otp'">
    </lib-rc-input>
  </div>

  <div class="is-in-send-otp" *ngIf="isInSendOtp">
    <a href="javascript:void(0);" (click)="sendOtp()">{{resend}}</a>
  </div>

    <br>
`,
  styles: [`.ltr .send-otp-text{padding-left:20px;height:16px;width:100%;color:#586d7d;font-family:Helvetica;font-size:13px;font-weight:300;line-height:16px}.rtl .send-otp-text{text-align:right;padding-right:20px;height:16px;width:100%;color:#586d7d;font-family:Helvetica;font-size:13px;font-weight:300;line-height:16px}.is-in-send-otp a{text-decoration:underline;cursor:pointer}.is-in-send-otp a .ltr{margin-left:15px}.is-in-send-otp a .rtl{margin-right:15px}`]
})
export class RcOtpComponent implements OnInit {
  otp: FormControl;
  otpSendMessage = '';
  errors = [];
  @Input() isInSendOtp = false;
  @Input() username: string;
  @Input() phoneNumber: string;
  @Input() recaptchaResponse: string;
  @Input() returnUrl: string;
  @Input() resend = 'Resend';
  @Output() otpSucceded: EventEmitter<string> = new EventEmitter();
  constructor(private authService: RcAuthService,
    private router: Router,
    private eventBusService: RcEventBusService) {
    this.otp = new FormControl('', []);

  }

  ngOnInit() {
    this.eventBusService.on('USE_OTP', (claims) => {
      if (this.isInSendOtp) {
        this.confirmOtp(claims);
      } else {
        this.sendOtp();
      }
    });
  }
  confirmOtp(claims): void {
    this.authService.OtpConfirm(this.username, this.otp.value, this.recaptchaResponse, claims)
      .pipe(first())
      .subscribe(() => {
        this.isInSendOtp = false;
        this.eventBusService.emit('OTP_SUCCEEDED', { username: this.username, otpCode: this.otp.value });
        if (this.returnUrl) {
          this.router.navigate([this.returnUrl]);
        }
      },
        e => {
         // this.errors = e.error.errors;
          this.eventBusService.emit('CONFIRM_OTP_ERROR', e);
        });
  }
  sendOtp(): void {
    this.authService.OTPSend(this.username, this.phoneNumber, this.recaptchaResponse)
      .pipe(first())
      .subscribe((res: any) => {
        this.eventBusService.emit('OTP_SENT_SUCCESS');
        this.isInSendOtp = true;
        this.username = res.content.username;
        this.otpSendMessage = 'otp sent to ' + res.content.phoneNumber;
      },
        e => {
          //this.errors = e.error.errors;
          this.eventBusService.emit('SEND_OTP_ERROR', e);
        });
  }
}
